<section class="messages-container">
  <!-- check chat alert -->
  @switch (alertState) {
    @case (AlertStatesEnum.publicChat) {
      <div class="messages-container__alert">
        <pwj-public-chat-form></pwj-public-chat-form>
      </div>
    }
    @case (AlertStatesEnum.supportChat) {
      <div class="messages-container__conversation">
        @if (isMessagesLoading) {
          <div class="messages-container__content">
            <!-- messages skeleton loader -->
            <pwj-messages-skeleton></pwj-messages-skeleton>
          </div>
        } @else {
          @if (messages.length > 0) {
            <!-- messages section -->
            <ul
              class="messages-container__list no-scrollbar"
              #messagesContainer>
              <!-- pagination -->

              @if (
                showPagination &&
                !isMessagesLoading &&
                messages.length < messagesCount
              ) {
                <li>
                  <pwj-pagination-on-scroll
                    [dataCount]="messagesCount"
                    [perPage]="20"
                    (setCurrentPage)="
                      fetchDataForNextPage()
                    "></pwj-pagination-on-scroll>
                </li>
              }
              <!-- messages list -->
              @for (message of messages; track i; let i = $index) {
                <li class="message-item" #message>
                  <pwj-message-box
                    [messageIndex]="i"
                    [messageData]="message"></pwj-message-box>
                </li>
              }
            </ul>
          } @else {
            <!-- suggestion messages list -->
            <ul class="messages-container__suggestions-list no-scrollbar">
              @for (message of suggestionMessages; track message) {
                <li class="message-item">
                  <pwj-suggest-message-box
                    [suggestedMessage]="message"></pwj-suggest-message-box>
                </li>
              }
            </ul>
          }
        }

        <!-- message input -->
        <pwj-chat-input class="messages-container__input"></pwj-chat-input>
      </div>
    }
    @default {
      <div>something went wrong</div>
    }
  }
</section>
